// need manoeuvre(enroulable(motorisé)) + need dimensions
import ManoeuvreElectrique from 'assets/img/manoeuvre-electrique.png';
import ManoeuvreManuel from 'assets/img/manoeuvre-manuel.png';
import formInputsTypes from '../simulatorConstant';
import Cassette from 'assets/img/cassette.png';
import Rainure from 'assets/img/rainure.png';
import Lisse from 'assets/img/lisse.png';
import Manuelle from 'assets/img/porte-manuel.png';
import Electrique from 'assets/img/porte-electrique.png';

export const panneauMotif = {
	id: 'PG-PAN-MOTIF',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'panneauMotif',
	className: 'col-12',
	label: 'Motif',
	nextStepData: false, // or next step (summary / contact / etc.)
	options: [
		{
			id: 'PG-PAN-MOTIF-LIS',
			label: 'Lisse',
			value: 'Lisse',
			imageUrl: Lisse,
			description:
				'Panneau à surface plane, offrant un rendu sobre et moderne. ' +
				'Facile d’entretien, il s’intègre discrètement à tous les styles de façade.',
		},
		{
			id: 'PG-PAN-MOTIF-RAI',
			label: 'Rainuré',
			value: 'Rainuré',
			imageUrl: Rainure,
			description:
				'Panneau avec rainures horizontales régulières, apportant du relief et une meilleure perception visuelle. ' +
				'Ce motif est couramment utilisé sur les portes sectionnelles.',
		},
		{
			id: 'PG-PAN-MOTIF-CAS',
			label: 'Cassette',
			value: 'Cassette',
			imageUrl: Cassette,
			description:
				'Panneau à motif cassette, composé de cadres en relief pour un aspect plus traditionnel ou décoratif. ' +
				'Souvent choisi pour des façades de caractère.',
		},
	],
};
const couleur = {
	id: 'VR-TR-TB-CC',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'Couleur du panneau',
	classGroup: 'Couleur du panneau',
	label: 'Couleur du panneau',
	defaultValue: 0,
	nextStepData: panneauMotif,
	options: [
		{
			id: 6,
			label: 'Blanc RAL 9016',
			color: '#ffffff',
			icon: 'CustomCircle',
			value: 6,
			description: '- Couleur blanc RAL 9016, aspect clair et standard.',
		},
		{
			id: 14,
			label: 'Anthracite RAL 7016',
			color: '#383e42',
			icon: 'CustomCircle',
			value: 14,
			description: '- Couleur gris anthracite RAL 7016, aspect moderne.',
		},
	],
};

const largeur = {
	id: 'VR-TR-VRC-W',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'largeur',
	className: 'col-6',
	label: 'Largeur du porte (mm)',
	placeholder: '0',
	defaultValue: 0,
	nextStepData: couleur, // keep your existing flow
	validation: (value) => value > 0,
};

const hauteur = {
	id: 'VR-TR-VRC-H',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'hauteur',
	className: 'col-6',
	label: 'Hauteur du porte (mm)',
	defaultValue: 0,
	placeholder: '0',
	nextStepData: largeur,
	validation: (value) => value > 0,
};

export const typeManoeuvre = {
	id: 'PG-TM',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'typeManoeuvre',
	className: 'col-6',
	label: 'Manœuvre',
	nextStepData: hauteur, // FIX: do not point to itself
	options: [
		{
			id: 'PG-TM-MNU',
			label: 'Manuel',
			value: 'Manuel',
			imageUrl: Manuelle,
			description: '- Manœuvre manuelle de la porte de garage.',
		},
		{
			id: 'PG-TM-ELE',
			label: 'Électrique',
			value: 'Électrique',
			imageUrl: Electrique,
			description: '- Manœuvre Électrique (commande murale / télécommande).',
		},
	],
};
